import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const i = t((o, s) => /* @__PURE__ */ e.jsx(
  r,
  {
    ref: s,
    ...o,
    image: (n) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...n,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M5 12.997a4 4 0 0 1-.022-.513c.007-.593-.33-1.16-1.01-1.791A6.2 6.2 0 0 1 2 6.143C2 2.777 4.66 0 8 0s6 2.777 6 6.143c0 1.8-.757 3.424-1.969 4.55-.68.631-1.016 1.198-1.009 1.791A4 4 0 0 1 11 13a3 3 0 1 1-6 0zM4 6.143C4 3.828 5.817 2 8 2s4 1.828 4 4.143c0 1.23-.516 2.328-1.33 3.085-.718.667-1.46 1.577-1.618 2.772H6.948c-.157-1.195-.9-2.105-1.618-2.772A4.2 4.2 0 0 1 4 6.143",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
i.displayName = "TungstenIcon";
export {
  i as TungstenIcon,
  i as default
};
//# sourceMappingURL=index.js.map
